import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import config from '@/site.config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    siteInfoLoaded:false,
    pageReady: true,
    siteInfo:null,
    pageData:{}

  },
  mutations: {

    setPageReady(state, value){
      state.pageReady = value;
    },

    addSiteInfo(state, data){
      state.siteInfo = data;
      state.siteInfoLoaded = true;
    },

    addPage(state,data){

      Vue.set(state.pageData, data.name, data.content)
    }
  },
  actions: {

    pageLoading({commit}){
      commit('setPageReady',false);
    },
    pageLoaded({commit}){
      commit('setPageReady',true);
    },

    async requestSiteInfo({commit}){

      if(this.state.siteInfo != null) return this.state.siteInfo;

      const res = await axios.get(config.API_PATH+'siteinfo')
      .catch((e) => {
          console.error(e)
          return false
      });
      commit('addSiteInfo',res.data)
      return res.data
    },

    async requestPageData({commit},{name,query,isSingle}){

      if(this.getters.existPageData(name)) {
        return this.state.pageData[name];
      }

      if(config.DEBUG) console.log(config.API_PATH+query)
      const res = await axios.get(config.API_PATH+query)
      .catch((e) => {
          console.error(e)
          return false
      });

      commit('addPage',{'name': name, 'content': isSingle ? res.data[0] : res.data})
      return isSingle ? res.data[0] : res.data
    }

  },

  getters: {

    existPageData: (state) => (name) =>{
      return state.pageData[name] != undefined;
    }
  },
  modules: {
  }
})
